// @flow

"use strict";

module.exports = {
  placementSettingBinder : "${__placement_setting__}",
  uzouDebugURLParamKey: "uzou_debug",
  uzouDebugURLParam: "1",
  articleResponseType : "article_response",
  adResponseType : "ad_response",
  mediaAdResponseType : "media_ad_response",
};


// WEBPACK FOOTER //
// ./src/js/constants/constants.js